import React from 'react';
import { Box } from '@mui/material';
import LowStockSummary from '../../components/Reports/LowStockSummary';

const LowStockSummaryPage: React.FC = () => {
  return (
    <Box>
      <LowStockSummary type="LOW_STOCK_SUMMARY" />
    </Box>
  );
};

export default LowStockSummaryPage;